import { InsuranceQuoteType, QuoteTypeCodes } from '@/interfaces';

export const getIconByCoverageCode = (coverageType: string) => {
  let insuranceIcon;
  switch (coverageType.toLowerCase()) {
    case QuoteTypeCodes[InsuranceQuoteType.HomeAndContents].toLowerCase():
      insuranceIcon = require('@/assets/icons/home-contents-no-tick.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.Home].toLowerCase():
      insuranceIcon = require('@/assets/icons/home-no-tick.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.Contents].toLowerCase():
      insuranceIcon = require('@/assets/icons/content-no-tick2.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.MotorComprehensive].toLowerCase():
      insuranceIcon = require('@/assets/icons/car.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.MotorFireTheftAndThirdPartyLiability].toLowerCase():
      insuranceIcon = require('@/assets/icons/car-fire-product.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.MotorThirdPartyLiability].toLowerCase():
      insuranceIcon = require('@/assets/icons/car-accident-product.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.Motorcycle].toLowerCase():
      insuranceIcon = require('@/assets/icons/motorcycle-product.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.PetComp].toLowerCase():
      insuranceIcon = require('@/assets/icons/pet-paw.svg');
      break;

    case QuoteTypeCodes[InsuranceQuoteType.BoatComprehensive].toLowerCase():
    case QuoteTypeCodes[InsuranceQuoteType.BoatThirdParty].toLowerCase():
      insuranceIcon = require('@/assets/icons/speed-boat-product.svg');
      break;
    case QuoteTypeCodes[InsuranceQuoteType.Caravan].toLowerCase():
      insuranceIcon = require('@/assets/icons/caravan-trailer-product.svg');
      break;
  }

  return insuranceIcon;
};
